<template>
  <v-app :class="{'no-macos':!isMacOS}">
    <arqana-header />
    <v-main>
      <router-view/>
    </v-main>
    <v-snackbar :color="snackbar.color" :timeout="snackbar.timeout" v-model="snackbar.active">{{ snackbar.text }}</v-snackbar>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue'
import ArqanaHeader from '@/components/shared/ArqanaHeader.vue'
import store from './store'
import snackbarStore from './store/snackbar'
import { isMacOS } from './utils/brower'

export default Vue.extend({
  name: 'App',
  data() {
    return {
      store,
      snackbar: snackbarStore.state.snackbar,
      overlay: false,

    }
  },
  computed: {
    isMacOS() {
      return isMacOS()
    },
  },
  components: {
    ArqanaHeader,
  },
  watch: {
    'store.state.expiredToken': function expiredToken(value) {
      if (value) {
        this.$router.push({
          path: '/login',
          query: { redirect: this.$route.fullPath, expired: 'expired' },
        })
      }
    },
  },
})
</script>

<style lang="scss">
  @import './src/styles/main.scss';
</style>
